module.exports = __webpack_public_path__ + "static/media/wintrust_103.474fc97e.ico";